export const PLANNING_TYPE = 'PLANNING';
export const WORKSPACE_WIZARD_TYPE = 'workspace';
export const JOB_WIZARD_TYPE = 'job';
export const OPTION_WIZARD_TYPE = 'option';
export const BUG_WIZARD_TYPE = 'bug';
export const REPLY_WIZARD_TYPE = 'reply';
export const IN_PROGRESS_WIZARD_TYPE = 'inProgress';
export const DISCUSSION_WIZARD_TYPE = 'discussion';
export const COMPOSE_WIZARD_TYPE = 'compose';
export const JOB_COMMENT_WIZARD_TYPE = 'jobComment';
export const JOB_COMMENT_CONFIGURE_WIZARD_TYPE = 'jobCommentConfigure';
export const DELETE_COMMENT_TYPE = 'deleteComment';
export const APPROVAL_WIZARD_TYPE = 'approval';
export const JOB_ASSIGNEE_WIZARD_TYPE = 'jobAssignee';
export const JOB_COLLABORATOR_WIZARD_TYPE = 'jobCollaborator';
export const JOB_APPROVERS_WIZARD_TYPE = 'jobApprover';
export const JOB_STAGE_WIZARD_TYPE = 'jobStage';
export const JOB_EDIT_WIZARD_TYPE = 'jobEdit';
export const OPTION_EDIT_WIZARD_TYPE = 'optionEdit';
export const DECISION_COMMENT_WIZARD_TYPE = 'decisionComment';
export const ADD_COLLABORATOR_WIZARD_TYPE = 'collaborator';
export const SIGN_OUT_WIZARD_TYPE = 'signOut';
export const DECISION_TYPE = 'DECISION';
export const INITIATIVE_TYPE = 'INITIATIVE';
export const ACTIVE_STAGE = 'Active';
export const SUPPORT_SUB_TYPE = 'SUPPORT';
export const TEST_SUB_TYPE = 'TEST';
export const DEMO_TYPE = 'DEMO';